export default __webpack_public_path__ + "static/media/home-blue.6e87bc88.svg";